import React from 'react'
import { Column } from 'components/common/layout'
import { FileInputBox, FileSelectedBox } from 'components/apply/file-input'
import { getUrlLastSegment } from 'utils/formatters'
import { isFileMaxSize } from 'utils/validations'
import { requestToast } from 'components/common/toast'
import { uploadFile } from 'utils/handlers'
import { WithIdLink } from 'types/common'

export const FileUploader: React.FC<{
  files: WithIdLink[]
  onChange: (e: WithIdLink) => void
  onRemove: (id: number) => void
  accept?: string[] | string
}> = ({ files, onChange, onRemove, accept }) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0]
      if (!file) return
      if (
        files.filter((item) => getUrlLastSegment(item.link).includes(file.name))
          .length > 0
      )
        return alert('중복된 파일입니다.')
      if (!isFileMaxSize(file.size))
        return alert('50MB 이하의 파일만 업로드 가능해요.')
      requestToast(
        uploadFile(e, '/accounts/me/application-files').then((res) => {
          if (!res) return
          onChange(res)
        }),
        {
          loading: '요청중',
          success: '파일이 업로드되었어요.',
        },
      )
      e.target.value = ''
    }
  }

  return (
    <Column style={{ gap: 8 }}>
      {files.map((item) => (
        <FileSelectedBox
          key={item.id}
          file={item}
          onRemove={() => onRemove(item.id)}
        />
      ))}
      <FileInputBox
        onChangeEvent={handleFileChange}
        isRecommendingPDF
        accept={accept}
      />
    </Column>
  )
}
